import { ComparePage } from "./ComparePage";
import { useLang } from "../lib/i18n";
import { compareFirefliesCopy } from "../lib/translations/pages/compare-fireflies";

export function CompareFireflies() {
  const lang = useLang();
  return <ComparePage copy={compareFirefliesCopy[lang]} path="/compare/fireflies-vs-minuta" />;
}
